import React, { useRef, useState } from 'react';
import styles from '../Header.module.scss';

import { BlueButton } from 'components/Buttons';
import MenuPopper from 'components/MenuPopper/MenuPopper';

import ExtensionIcon from '@material-ui/icons/Extension';
import AssignmentIcon from '@material-ui/icons/Assignment';
import { ReactComponent as GearIcon } from 'assets/images/gear.svg';
import LibraryAddIcon from '@material-ui/icons/LibraryAdd';

import { MenuItem } from '@material-ui/core';

export function AddPicklistItemsButton({ onAddAssets, onAddLooseItems, onAddBOM, onAddAssembly }) {
  const anchorRef = useRef(null);
  const [openMenu, setOpenMenu] = useState(false);

  const handleClick = () => setOpenMenu(!openMenu);
  const closeMenu = () => setOpenMenu(false);

  const handleItemClick = (fn) => {
    fn();
    closeMenu();
  };

  return (
    <div className={styles.add_items}>
      <BlueButton
        label="Add Items"
        ref={anchorRef}
        onClick={handleClick}
        className={styles.add_items__btn}
      />
      <MenuPopper
        open={openMenu}
        setOpen={setOpenMenu}
        anchorRef={anchorRef}
        classes={styles.add_items__menu}>
        <MenuItem onClick={() => handleItemClick(onAddAssets)}>
          <GearIcon />
          Add Assets
        </MenuItem>
        <MenuItem onClick={() => handleItemClick(onAddLooseItems)}>
          <ExtensionIcon />
          Add Loose Items
        </MenuItem>
        <MenuItem onClick={() => handleItemClick(onAddBOM)}>
          <AssignmentIcon />
          Add BOM
        </MenuItem>
        <MenuItem onClick={() => handleItemClick(onAddAssembly)}>
          <LibraryAddIcon />
          Add Assembly
        </MenuItem>
      </MenuPopper>
    </div>
  );
}
